// src/App.js
import React from 'react';
import Title from './components/title'

function App() {
  return (
    <div className="App">
      <Title/>
    </div>
  );
}

export default App;
